import styled from "@emotion/styled";
import { fontAngkor, fontFredoka } from "@product/scmp-sdk";

import { ContentCoverImage } from "~/components/content/content-cover-image";
import { Figure } from "~/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "~/components/content/content-headline/styles";
import { EntityLink } from "~/components/entity-link";
import { Button } from "~/components/posties/button";
import { OffsetContainer } from "~/components/posties/offset-container";
import { setOffsetContainerCssVariables } from "~/components/posties/offset-container/styles";

import ArrowButton from "./img-arrow-button.svg";

export const StyledButton = styled(Button)``;

export const StyledContentCoverImage = styled(ContentCoverImage)`
  border-radius: 12px;
  ${props => props.theme.breakpoints.up("tablet")} {
    border-radius: 20px;
  }
`;

export const StyledOffsetContainer = styled(OffsetContainer)`
  margin-block-end: 5px;
  margin-inline-start: 5px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 8px;
    margin-inline-start: 8px;
    ${setOffsetContainerCssVariables({ $borderRadius: "20px" })}
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-end: 10px;
    margin-inline-start: 10px;
  }

  ${Figure} {
    position: relative;
    inset-block-start: 5px;
    inset-inline-end: 5px;

    inline-size: 100%;
    block-size: 100%;

    border-radius: 12px;

    ${props => props.theme.breakpoints.up("tablet")} {
      inset-block-start: 8px;
      inset-inline-end: 8px;

      border-radius: 20px;
    }
    ${props => props.theme.breakpoints.up("desktop")} {
      inset-block-start: 10px;
      inset-inline-end: 10px;
    }
  }
`;

export const Cover = styled.div``;

export const Headline = styled.div`
  ${ContentHeadline}, ${SponsorHeadline} {
    color: #333333;
    font-size: 24px;
    font-family: ${fontAngkor};
    line-height: 28px;
    letter-spacing: -0.72px;

    ${props => props.theme.breakpoints.up("tablet")} {
      font-size: 32px;
      line-height: 38px;
      letter-spacing: -0.96px;
    }
  }
`;

export const DateContainer = styled.div`
  color: #555555;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontFredoka};
  font-style: normal;
  line-height: 24px;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const StyledArrowButton = styled(ArrowButton)``;

export const Content = styled.div`
  display: grid;
  grid:
    "headline ." min-content
    "date arrow" min-content
    / auto min-content;
  gap: 8px;
  align-items: center;
  ${Headline} {
    grid-area: headline;
  }

  ${DateContainer} {
    grid-area: date;
  }

  ${StyledArrowButton} {
    grid-area: arrow;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "headline" min-content
      "." 12px
      "date" min-content
      "." 20px
      "arrow" min-content
      / auto;
    gap: 0;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid:
      "headline" min-content
      "." 16px
      "date" min-content
      "." 24px
      "arrow" min-content
      / auto;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "cover" min-content
    "content" min-content
    / auto;
  gap: 29px;
  align-items: start;

  ${Cover} {
    grid-area: cover;
  }

  ${Content} {
    grid-area: content;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "cover content" min-content
      / 242px auto;
    gap: 24px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid:
      "cover content" min-content
      / 320px auto;
    gap: 24px;
  }
`;

export const Container = styled.div``;
